var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.476 0h17.043c.816 0 1.479.646 1.479 1.442v17.114c0 .796-.663 1.443-1.48 1.443H1.477C.662 19.999 0 19.352 0 18.556V1.442C0 .646.662 0 1.476 0m12.6 17.041h2.966v-5.234c0-2.57-.555-4.546-3.558-4.546-1.443 0-2.411.79-2.807 1.541h-.04V7.497H7.79v9.544h2.965v-4.72c0-1.245.236-2.452 1.78-2.452 1.521 0 1.54 1.424 1.54 2.53zM2.729 4.474a1.72 1.72 0 1 0 3.439 0 1.72 1.72 0 0 0-3.439 0M5.931 17.04H2.964V7.497H5.93z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedin;